import { combineReducers } from 'redux';
import authReducer from './authReducer';
import deviceReducer from './deviceReducer';
import driverReducer from './driverReducer';
import driversReducer from './driversReducer';
import projectReducer from './projectReducer';
import projectsReducer from './projectsReducer';
import lumInfosReducer from './lumInfosReducer';
import ledModulesReducer from './ledModulesReducer';
import errorsReducer from './errorsReducer';
import brandReducer from './brandReducer';
import headerWarningReducer from './headerWarningReducer';

export default combineReducers({
    auth: authReducer,
    devices: deviceReducer,
    drivers: driversReducer,
    driver: driverReducer,
    projects: projectsReducer,
    project: projectReducer,
    lumInfos: lumInfosReducer,
    ledModules: ledModulesReducer,
    errorsHandler: errorsReducer,
    brand: brandReducer,
    headerWarning: headerWarningReducer
});
